<template>
  <f7-page login-screen class="login-page">
    <div class="login-hero">
      <f7-icon
        ios="f7:lock_rotation"
        md="material:lock_reset"
        class="login-hero-icon"
        color="primary"
      />
      <f7-login-screen-title>Zabudnuté heslo</f7-login-screen-title>
    </div>

    <f7-card class="login-card">
      <f7-card-content>
        <f7-block-header class="margin-bottom">
          <p>Zadajte e-mail, s ktorým sa prihlasujete. Pošleme Vám odkaz na obnovenie hesla.</p>
        </f7-block-header>

        <form @submit.prevent="requestReset">
          <f7-list dividers-ios no-hairlines class="no-margin">
            <f7-list-input
              v-model:value.trim="email"
              label="E-mail"
              type="email"
              placeholder="Váš e-mail"
              @keydown.enter.prevent="
                ;($event.target as HTMLElement)?.blur()
                requestReset()
              "
            />
          </f7-list>
        </form>
        <f7-button large tonal color="secondary" class="margin-top" @click="requestReset"
          >Odoslať odkaz</f7-button
        >
        <f7-button small color="primary" class="margin-top-half" @click="$emit('back')"
          >Späť na prihlásenie</f7-button
        >
      </f7-card-content>
    </f7-card>
  </f7-page>
</template>
<script setup lang="ts">
import { f7 } from 'framework7-vue'
import { ref } from 'vue'

import { getAuthRedirectUrl, RESET_PASSWORD_PATH } from '@/assets/composables/auth'
import { runReportedAction } from '@/assets/composables/diagnostics'
import { resetPasswordForEmail } from '@/assets/composables/endpoints'

const emit = defineEmits<{ back: [] }>()

const email = ref<string>('')
const loading = ref<boolean>(false)

const requestReset = async () => {
  if (loading.value) return

  if (email.value === '') {
    f7.dialog.alert('Vyplňte prosím e-mail.')
    return
  }

  loading.value = true
  f7.preloader.show()
  try {
    const succeeded = await runReportedAction(
      () => resetPasswordForEmail(email.value, getAuthRedirectUrl(RESET_PASSWORD_PATH)),
      {
        area: 'auth',
        operation: 'password-reset',
        endpoint: '/auth/v1/recover',
        title: 'Odkaz sa nepodarilo odoslať',
        message:
          'Odkaz na obnovenie hesla sa nepodarilo odoslať. Skontrolujte e-mail a skúste to prosím neskôr.',
      },
    )

    if (!succeeded) return

    email.value = ''
    emit('back')
    f7.dialog.alert(
      'Na zadaný e-mail sme Vám odoslali odkaz na obnovenie hesla.',
      'Skontrolujte si e-mail',
    )
  } finally {
    loading.value = false
    f7.preloader.hide()
  }
}
</script>

<style scoped>
.login-page {
  --f7-login-screen-title-font-size: 28px;
  --f7-login-screen-title-font-weight: 700;
}

.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  padding-bottom: 24px;
}

.login-hero-icon {
  font-size: 56px;
  margin-bottom: 8px;
}

.login-card {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.login-card :deep(.item-content.item-input) {
  margin-left: 0;
  margin-right: 0;
}
</style>
